<script lang="ts">
	import Blok from '$lib/storyblok/blok.svelte';
	import { editable } from '$lib/storyblok/editable';
	import type { ISbStoryData } from '@storyblok/js';
	import type { PdpSubnavItem } from './pdpSubnavItem.svelte';

	interface Props {
		content: ISbStoryData<{
			items: Array<PdpSubnavItem>;
		}>['content'];
	}

	let { content }: Props = $props();

	let active = $state<string | undefined>();
</script>

<div use:editable={content}>
	{#each content.items as item}
		<Blok
			content={item}
			active={active === item.anchor}
			onopen={() => (active = item.anchor)}
			onclose={() => (active = undefined)}
		/>
	{/each}
</div>
